"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    COMMON_APP_PDF: 'Common App PDF',
    COMMON_APP_ESSAY: 'Common App Essay',
    UC_PDF: 'UC PDF',
    UC_ESSAY: 'UC Essay',
    UCAS_PDF: 'UCAS PDF',
    UCAS_PERSONAL_STATEMENT: 'UCAS Personal Statement',
    EU_CV_PDF: 'EU CV PDF',
    EU_APP_ESSAY: 'EU Application Essay',
    OTHER: 'Other Essay',
    OTHER_FILE: 'Other File',
};
//# sourceMappingURL=appEssayTypes.js.map